module.exports = __webpack_public_path__ + "static/media/create-first-area-2.4841988a.svg";